import { render } from "./EmployeeEdit.vue?vue&type=template&id=af5f6fb0"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__